import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Tooltip from '@mui/material/Tooltip';
import AddCardIcon from '@mui/icons-material/AddCard';
import WebAssetIcon from '@mui/icons-material/WebAsset';
import './style.css';
import Icons from '../../icons/iconts';
import { useEffect } from 'react';

export const DISPLAY_TYPE = {
    INLINE: 'inline',
    NONE: 'none'
}

export interface MenuContextProps {
    display?: string;
    clickedAdd?: () => void;
    clickedEdit?: () => void;
    clickedDelete?: () => void;
    clickedFinancial?: () => void;
    clickedFinancialModal?: () => void; 
    clickedFinished?: () => void;
    addTooltip?: string;
    editTooltip?: string;
    deleteTooltip?: string;
    financialTooltip?: string;
    financialModalTooltip?: string;
    showAdd?: boolean;
    fontSize?: number;
    showEdit?: boolean;
    showDelete?: boolean;
    showFinancial?: boolean;
    showFinancialModal?: boolean;
    showDeleteIcon?: boolean;
    showFinished?: boolean;
}

const MenuContext = ({ 
    display = DISPLAY_TYPE.INLINE, 
    clickedAdd, 
    clickedEdit, 
    clickedDelete,
    clickedFinancial,
    clickedFinancialModal,
    clickedFinished,
    addTooltip = "Adicionar",
    editTooltip = "Editar",
    deleteTooltip = "Excluir",
    financialTooltip = "Financeiro",
    financialModalTooltip = "Movimentações Financeiras",
    showAdd = true,
    showEdit = false,
    showDelete = false,
    showFinancial = false,
    showFinancialModal = false,
    showDeleteIcon = false,
    showFinished = false,
    fontSize = 35
}: MenuContextProps) => {
    return (
        <div className="container-menu-context">
            {showAdd && (
                <Tooltip title={addTooltip}>
                    <AddCircleOutlineIcon 
                        style={{ display: display === DISPLAY_TYPE.INLINE ? 'block' : 'none' }} 
                        className="icons-menu-context"  
                        key={'add'} 
                        onClick={clickedAdd}
                        sx={{ fontSize }}
                    />
                </Tooltip>
            )}
            
            {showEdit && (
                <Tooltip title={editTooltip}>
                    <EditIcon 
                        style={{ display: display === DISPLAY_TYPE.INLINE ? 'block' : 'none' }} 
                        className="icons-menu-context"  
                        key={'edit'}
                        onClick={clickedEdit}
                        sx={{ fontSize }}
                    />
                </Tooltip>
            )}
            
            {showDelete && (
                <Tooltip title={deleteTooltip}>
                    <DeleteIcon 
                        style={{ display: display === DISPLAY_TYPE.INLINE ? 'block' : 'none' }} 
                        className="icons-menu-context"  
                        key={'delete'}
                        onClick={clickedDelete}
                        sx={{ fontSize }}
                    />
                </Tooltip>
            )}

            {showFinancial && (
                <Tooltip title={financialTooltip}>
                    <AddCardIcon 
                        style={{ display: display === DISPLAY_TYPE.INLINE ? 'block' : 'none' }} 
                        className="icons-menu-context"  
                        key={'financial'}
                        onClick={clickedFinancial}
                        sx={{ fontSize }}
                    />
                </Tooltip>
            )}

            {showFinancialModal && (
                <Tooltip title={financialModalTooltip}>
                    <WebAssetIcon 
                        style={{ display: display === DISPLAY_TYPE.INLINE ? 'block' : 'none' }} 
                        className="icons-menu-context"  
                        key={'financial'}
                        onClick={clickedFinancialModal}
                        sx={{ fontSize }}
                    />
                </Tooltip>
            )}

            {showDeleteIcon && (
                <Tooltip title={deleteTooltip}>
                      <Icons
                        iconName="Delete" 
                        addTooltip={deleteTooltip} 
                        iconClicked={clickedDelete}
                        color={'#4db0b1'}
                        fontSize={fontSize}/>
                </Tooltip>
            )}

            {showFinished && (
                <Tooltip title={'Concluir'}>
                      <Icons
                        iconName="DoneAll" 
                        addTooltip={'Concluir'} 
                        iconClicked={clickedFinished}
                        color={'#4db0b1'}
                        fontSize={fontSize}/>
                </Tooltip>
            )}
            </div>
    )
}

export default MenuContext;